/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_shipping_amount = /** @type {(inputs: {}) => string} */ () => {
	return `Poplatek za dopravu`
};

const da_shipping_amount = /** @type {(inputs: {}) => string} */ () => {
	return `Leveringsomkostninger`
};

const de_shipping_amount = /** @type {(inputs: {}) => string} */ () => {
	return `Versandkosten`
};

const en_shipping_amount = /** @type {(inputs: {}) => string} */ () => {
	return `Shipping amount`
};

const es_shipping_amount = /** @type {(inputs: {}) => string} */ () => {
	return `Gastos de envío`
};

const fr_shipping_amount = /** @type {(inputs: {}) => string} */ () => {
	return `Frais de port`
};

const hu_shipping_amount = /** @type {(inputs: {}) => string} */ () => {
	return `Szállítási költség`
};

const it_shipping_amount = /** @type {(inputs: {}) => string} */ () => {
	return `Spese di spedizione`
};

const nl_shipping_amount = /** @type {(inputs: {}) => string} */ () => {
	return `Verzendkosten`
};

const pl_shipping_amount = /** @type {(inputs: {}) => string} */ () => {
	return `Koszt wysyłki`
};

const pt_shipping_amount = /** @type {(inputs: {}) => string} */ () => {
	return `Frete`
};

const sv_shipping_amount = /** @type {(inputs: {}) => string} */ () => {
	return `Fraktkostnad`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const shipping_amount = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.shipping_amount(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("shipping_amount", locale)
	if (locale === "cs") return cs_shipping_amount(inputs)
	if (locale === "da") return da_shipping_amount(inputs)
	if (locale === "de") return de_shipping_amount(inputs)
	if (locale === "en") return en_shipping_amount(inputs)
	if (locale === "es") return es_shipping_amount(inputs)
	if (locale === "fr") return fr_shipping_amount(inputs)
	if (locale === "hu") return hu_shipping_amount(inputs)
	if (locale === "it") return it_shipping_amount(inputs)
	if (locale === "nl") return nl_shipping_amount(inputs)
	if (locale === "pl") return pl_shipping_amount(inputs)
	if (locale === "pt") return pt_shipping_amount(inputs)
	return sv_shipping_amount(inputs)
};